import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=2e508a40&scoped=true&"
import script from "./dashboard-page.vue?vue&type=script&lang=js&"
export * from "./dashboard-page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dashboard-page.vue?vue&type=style&index=1&id=2e508a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e508a40",
  null
  
)

export default component.exports